import { useAppDispatch } from '@redux/hooks';
import { setTitle } from '@redux/pageTitle';
import { useCallback, useEffect } from 'react';

const DEFAULT_TITLE = 'Rocky';

export const useTitle = (): ((title: string) => void) => {
  const dispatch = useAppDispatch();

  const setPageTitle = useCallback(
    (title: string) => {
      dispatch(setTitle(title));
    },
    [dispatch],
  );

  useEffect(() => {
    return () => {
      dispatch(setTitle(DEFAULT_TITLE));
    };
  }, [dispatch]);

  return setPageTitle;
};
